(function () {
    'use strict';

    angular
        .module('app.application.role')
        .controller('RoleAddController', RoleAddController);

    /* @ngInject */
    function RoleAddController(applictionID,
        logger,
        applicationService,
        roleService,
        $uibModalInstance,
        moment,
        $q,
        $filter) {
        //Private Variables
        var vm = this;
        var applications = [];

        //Public Variables
        vm.title = 'Add Role';
        vm.role = roleService.getDefaultRole(applictionID);

        //Public Methods
        vm.save = save;
        vm.reset = reset;

        //Activate Controller
        activate();

        function activate() {
            var promises = [getApplications()];
            return $q.all(promises).then(function () {
                setForm(applications);
                logger.info('Activated Role Add View');
            });
        }

        function save() {
            if (vm.roleForm.$valid) {
                roleService.saveRole(vm.role)
                    .then(function (result) {
                        if (result.status === 200) {
                            var application = $filter('filter')(
                                vm.roleFields[2].templateOptions.options, {
                                    ApplicationId: result.data.ApplicationId
                                }, true);

                            result.data.Application = application[0];
                            $uibModalInstance.close(result.data);
                        } else {
                            logger.info('issue saving role');
                        }
                    });
            }
        }

        function reset() {
            vm.roleForm.options.resetModel();
            $uibModalInstance.dismiss('cancel');
        }

        //Private Methods
        function getApplications() {
            return applicationService.getApplications()
                .then(function (result) {
                    applications = result;
                });
        }

        function setForm(applications) {
            vm.roleFields = roleService.getRoleFields(applictionID, applications);
        }
    }
})();
